<template>
  <div class="global-body-style">
    <div class="b-conditions-style">
      <div class="b-con-form">
        <label class="c-label">项目</label>
        <single-auto-complete class="b-con-filter-area" v-bind:model_id.sync="condition.id" :selectOptions="{apiType: 'houses', params: {is_all: 1}}" />
      </div>
      <div class="b-con-form">
        <label class="c-label">区域</label>
        <single-auto-complete class="b-con-filter-area" v-bind:model_id.sync="condition.area_id" :selectOptions="{apiType: 'citys', params: {type: 2}}" />
      </div>
      <div class="b-con-form">
        <label class="c-label">是否上架</label>
        <el-select class="b-con-filter-area" v-model="condition.status" placeholder="请选择">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="2"></el-option>
        </el-select>
      </div> 
      <div class="c-con-search-btn">
        <button class="global-btn primary size-1" @click="search">搜索</button>
        <button class="global-btn primary-round size-1" @click="searchMore">搜索更多</button>
      </div>
    </div>
    <div class="b-inner-menus b-inner-menus-dist" v-if="userInfo.is_no_secret_login != 1">
      <div class="b-inner-flex">
        <p class="b-i-menu" @click="addProject">
          <i class="iconfont iconxinzeng b-i-icon"></i>
          <span>新增</span>
        </p>
        <p class="b-i-menu" @click="$router.push('/customer/import/batch/list?type=project')">
          <i class="iconfont iconhebing b-i-icon"></i>
          <span>批量导入</span>
        </p>
        <p class="b-i-menu" @click="handleExport" v-permission="'project.list.export'">
          <i class="iconfont iconhebing b-i-icon"></i>
          <span>导出</span>
        </p>
      </div>
    </div>
    <cu-table :tableColumn="field" :isLoading="isLoading" :pageData="pageCondition" :data="list" @currentChange="currentChange" >
      <template slot="operate">
        <el-table-column label="是否上架">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="2" active-color="#25a0ff" :disabled="!disabledPermission"
                      inactive-color="#bfbfbf" @change="e => statusChange(scope.row, e)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110" fixed="right">
          <template slot-scope="scope">
            <div class="table-operation">
              <a class="ope-item" @click="toEdit(scope.row)" v-permission="'project.list.edit'">编辑</a>
              <a class="ope-item" @click="toDelete(scope.row)" v-permission="'project.list.delete'" >删除</a>
            </div>
          </template>
        </el-table-column>
      </template>
    </cu-table>
    <project-list-condition v-bind:isOpen.sync="isOpenConditionMore" ref="moreConditionRef" @comfirmCheck="handleMoreSearchConfirm" @reset="handleMoreSearchReset" />
  </div>
</template>
<script>
import {configKeys} from '@/setting/index';
import {getProjectList} from '@/api/base';
import {editProjectStatus, exportProject, deleteProject} from '@/api/project';
import SingleAutoComplete from '@/components/select/SingleAutoComplete';
import CuTable from '@/components/cTable';
import {projectListField} from '@/utils/field';
import { mapState } from 'vuex';
import {download} from '@/utils/index';
export default {
  name: 'ProjectList',
  components: {
    SingleAutoComplete,
    CuTable,
    ProjectListCondition: resolve => (require(["./moreCondition"], resolve)),
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isOpenConditionMore: false, // 是否打开更多搜索
      field: projectListField,
      isLoading: false,
      list: [],
      pageCondition: {
        per_page: 20,
        page: 1,
        total: 0,
      },
      condition: {
        id: '',
        area_id: '',
        coop_status: '',
        status: 1
      },
      options: {},
      disabledPermission: false
    }
  },
  computed: {
    ...mapState({
      companyInfo: state => state.user.companyInfo,
      emitName: state => state.const.emitName,
      userInfo: state => state.user.userInfo
    })
  },
  async created() {
    this.initList();
    this.options = await this.$store.dispatch('initConfig', [configKeys.project_coop_status]);
    // 欢迎页-判断是否直接跳转到新增项目弹层
    const {origin} = this.$route.query;
    const hasAddPermission = await this.$store.dispatch('user/hasPermission', 'customer.invalid.list.batch-move');
    if (origin === 'new' && hasAddPermission) {
      this.addProject();
    }
    // 是否有编辑项目的权限
    this.disabledPermission = await this.$store.dispatch('user/hasPermission', 'project.list.edit');
  },
  methods: {
    search() {
      this.currentChange(1);
    },
    searchMore () {
      this.isOpenConditionMore = true;
      this.$refs?.moreConditionRef?.changeParams?.(this.condition);
    },
    // 搜搜更多-选择回调
    handleMoreSearchConfirm (data) {
      this.condition = {
        ...this.condition,
        ...data
      }
      this.search();
    },
    // 搜搜更多-重置回调
    handleMoreSearchReset (data) {
      this.condition = {
        ...data,
        id: '',
        area_id: '',
        coop_status: '',
        status: 1
      }
      this.search();
    },
    reload() {
      this.initList();
    },
    // 跳转编辑详情页
    toEdit(row) {
      this.$EventBus.$emit(this.emitName, {category: 'operateProject', params: {
        type: 'edit',
        projectInfo: {...row}
      }});
    },
    addProject() {
      this.$EventBus.$emit(this.emitName, {category: 'operateProject', params: {
        type: 'new'
      }});
    },
    // 初始化列表
    async initList() {
      this.isLoading = true;
      try {
        const params = {...this.condition, ...this.pageCondition};
        const res = await getProjectList(params);
        this.list = res.data || [];
        this.$set(this.pageCondition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    // 分页回调
    currentChange(page) {
      this.pageCondition.page = page;
      this.initList();
    },
    // 修改项目状态
    statusChange(row, status) {
      this.$confirm(status === 1 ? '确认上架该项目？' : '确认下架该项目？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async () => {
        try {
          const res = await editProjectStatus(row.id);
          this.$message.success('操作成功');
          this.initList();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
          row.status = row.status === 1 ? 2 : 1;
        }
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1;
      })
    },
    async handleExport () {
      if (this.pageCondition.total === 0) {
        this.$message.error('没有可导出的数据');
        return null;
      }
      try {
        await exportProject(this.condition);
        this.$EventBus.$emit(`importAnimate`, 1);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    toDelete (row) {
      this.$confirm('删除后，不再会有本项目的数据统计，是否确认删除项目？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          const res = await deleteProject(row.id);
          this.$message.success('删除成功');
          this.initList();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/base/condition.less');
@import url('~@/assets/style/base/search.less');
</style>